import { useBAIi18n } from '../hooks/useBAIi18n';
import { theme, Tooltip, Typography } from 'antd';
import { CircleXIcon } from 'lucide-react';
import React from 'react';

export interface BAISelectionLabelProps {
  count: number;
  onClearSelection?: () => void;
}

const BAISelectionLabel: React.FC<BAISelectionLabelProps> = ({
  count,
  onClearSelection,
}) => {
  'use memo';

  const { t } = useBAIi18n();
  const { token } = theme.useToken();

  if (count <= 0) return null;

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      <Typography.Text>{t('general.NSelected', { count })}</Typography.Text>
      {onClearSelection && (
        <Tooltip title={t('general.DeselectAll')}>
          <CircleXIcon
            size={16}
            tabIndex={0}
            role="button"
            aria-label={t('general.DeselectAll')}
            style={{
              cursor: 'pointer',
              color: token.colorTextSecondary,
              flexShrink: 0,
            }}
            onClick={onClearSelection}
          />
        </Tooltip>
      )}
    </span>
  );
};

export default BAISelectionLabel;
